import React, { createContext, useContext, useEffect, useState } from "react";
import * as authService from "../services/auth";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading
  const [ready, setReady] = useState(false);

  const loadMe = async () => {
    const token = localStorage.getItem("sl_token");
    if (!token) { setUser(false); setReady(true); return; }
    try {
      const data = await authService.getUserProfile();
      setUser(data);
    } catch (e) {
      localStorage.removeItem("sl_token");
      setUser(false);
    } finally {
      setReady(true);
    }
  };

  useEffect(() => { loadMe(); }, []);

  const applyAuth = (data) => {
    localStorage.setItem("sl_token", data.token);
    setUser(data.user);
  };

  const logout = async () => {
    try { await authService.logout(); } catch (e) {}
    localStorage.removeItem("sl_token");
    setUser(false);
  };

  const refreshUser = async () => {
    const data = await authService.getUserProfile();
    setUser(data);
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, ready, applyAuth, logout, refreshUser, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
